export default __webpack_public_path__ + "static/media/Image.2a4f9239.svg";